export {
  SuggestionTitle as Title,
  type SuggestionTitleProps as TitleProps,
} from "./suggestion/SuggestionTitle";
export {
  SuggestionDescription as Description,
  type SuggestionDescriptionProps as DescriptionProps,
} from "./suggestion/SuggestionDescription";
export {
  SuggestionTrigger as Trigger,
  type SuggestionTriggerProps as TriggerProps,
} from "./suggestion/SuggestionTrigger";
